<!-- new header section -->
<div class="header">
  <header class="d-flex flex-wrap align-items-center justify-content-center justify-content-md-between py-3 mb-4 border-bottom px-4">
    <div class="col-md-3 mb-2 mb-md-0">
      <a [routerLink]="['/']" class="d-inline-flex link-body-emphasis text-decoration-none">
        <!-- <svg class="bi" width="40" height="32" role="img" aria-label="Bootstrap"><use xlink:href="#bootstrap"></use></svg> -->
        <img src="../../assets/images/landing/GeoAstra_logo_white_Transparent_1300x300.png" width="200" height="46" alt="GeoAstra Logo">
      </a>
    </div>

    <!-- 顶部导航（含二级下拉） -->
    <ul class="nav col-12 col-md-auto mb-2 justify-content-center mb-md-0">
      <!-- Ntrip Expert dropdown (available for downloader-pro, analyzer-pro, or demo) -->
      <li class="nav-item dropdown" *ngIf="canSeeRtkExpert">
        <a class="nav-link px-2 dropdown-toggle" href="#" id="rtkExpertMenu" role="button">RTK Expert Tool Suite</a>
        <ul class="dropdown-menu" aria-labelledby="rtkExpertMenu">
          <li *ngIf="auth.isLoggedIn()"><a class="dropdown-item" [routerLink]="['/ppk-studio']">PPK Studio</a></li>
          <li *ngIf="isDownloaderPro || isDemo"><a class="dropdown-item" [routerLink]="['/ppk-downloader-pro']">PPK Downloader (Pro Edition)</a></li>
          <li *ngIf="isAnalyzerPro || isDownloaderPro || isDemo"><a class="dropdown-item" [routerLink]="['/rtk-base-analyzer-pro']">RTK Base Analyzer (Pro Edition)</a></li>
        </ul>
      </li>

      <!-- My Profile dropdown (hover) -->
      <li class="nav-item dropdown" *ngIf="auth.isLoggedIn()">
        <a class="nav-link px-2 dropdown-toggle" href="#" id="myProfileMenu" role="button">My Profile</a>
        <ul class="dropdown-menu" aria-labelledby="myProfileMenu">
          <li><a class="dropdown-item" href="user-profile">My Profile</a></li>
          <li><a class="dropdown-item" href="license">License</a></li>
        </ul>
      </li>

      <!-- Help dropdown -->
      <li class="nav-item dropdown">
        <a class="nav-link px-2 dropdown-toggle" href="#" id="helpMenu" role="button">Help</a>
        <ul class="dropdown-menu" aria-labelledby="helpMenu">
          <li><a class="dropdown-item" href="https://community.geoastra.com/documents/" target="_blank" rel="noopener">Documentation</a></li>
          <li><a class="dropdown-item" href="https://community.geoastra.com/tech-support/" target="_blank" rel="noopener">Support Forums</a></li>
          <li><a class="dropdown-item" href="https://community.geoastra.com/" target="_blank" rel="noopener">Blogs</a></li>
          <li><a class="dropdown-item" href="https://community.geoastra.com/newsroom/" target="_blank" rel="noopener">News</a></li>
          <li><hr class="dropdown-divider"></li>
          <li><a class="dropdown-item" href="#" data-bs-toggle="modal" data-bs-target="#aboutCasterModal">About GeoAstra NTRIP Caster</a></li>
        </ul>
      </li>

      <!-- Shop dropdown -->
      <li class="nav-item dropdown">
        <a class="nav-link px-2 dropdown-toggle" href="#" id="shopMenu" role="button">Shop</a>
        <ul class="dropdown-menu" aria-labelledby="shopMenu">
          <li><a class="dropdown-item" href="https://gpswebshop.com/" target="_blank" rel="noopener">GPSWebShop</a></li>
          <li><a class="dropdown-item" href="https://canadagps.ca/" target="_blank" rel="noopener">Canada GPS</a></li>
        </ul>
      </li>
    </ul>

    <!-- About GeoAstra NTRIP Caster Modal -->
    <div class="modal fade" id="aboutCasterModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content about-modal">
          <div class="modal-body text-center p-4">
            <img src="../../assets/images/landing/GeoAstra_logo_200x200.png" alt="GeoAstra Logo" class="about-logo mb-3">
            <div class="about-title">GeoAstra NTRIP Caster</div>
            <div class="about-version">Version 2.0</div>
            <div class="my-3" style="height: 12px;"></div>
            <button type="button" class="btn btn-primary px-4" data-bs-dismiss="modal">Ok</button>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-3 text-end">      
      <button type="button" class="btn btn-warning" (click)="logOut()">Sign-out</button>
    </div>
    
  </header>
</div>


